import React from 'react';

import Team from 'models/team';
import PropTypes from 'prop-types';

import { PAGE_TYPES } from 'constants/ProjectConstants';

import ListContainerComponent from './ListContainer';

export default function TasksListV1({
  stats = {
    delayed: 0,
    ongoing: 0,
    unplanned: 0,
    completed: 0,
    highProgress: 0,
    mediumProgress: 0,
    lowProgress: 0,
    onTrackProgress: 0,
    offTrackProgress: 0,
    atRiskProgress: 0,
    closedProgress: 0,
  },
  employee,
  // can be either TEAM or TAG, team is used for home, profile and team page; tag is used for hashtag page
  type: viewType,
  source,
  timeBoundPeriod = null,
  selectedCohort = null,
}) {
  return (
    <ListContainerComponent.ListContainer
      employee={employee}
      type={viewType}
      // showType={'ACTIVE'}
      stats={stats}
      viewType={viewType}
      source={source}
      timeBoundPeriod={timeBoundPeriod}
      selectedCohort={selectedCohort}
    />
  );
}

TasksListV1.propTypes = {
  team: PropTypes.objectOf(Team).isRequired,
  updateTeam: PropTypes.func,
  pageType: PropTypes.oneOf(Object.values(PAGE_TYPES)),
};
